import { StyleSheet } from "react-native";

const globalStyles = StyleSheet.create({
  textField: {
    borderRadius: 20,
    height: 52.5,
    backgroundColor: "#e7e7e8",
    width: "100%",
    padding: 12.5,
  },
  subheaderText: {
    fontSize: 20,
    color: "#898c8e",
    marginLeft: 11,
    fontFamily: "HelveticaNeueLTPro-Bd",
  },
});

export default globalStyles;
